import { createFileRoute } from '@tanstack/react-router';

import { ImageEditPage } from '@/components/admin/image-edit-page';
import { useAdminEditPageKey } from '@/hooks/use-admin-navigate';
import { adminHead } from '@/lib/seo';
import { adminGetImageFn } from '@/server/functions/admin';

export const Route = createFileRoute('/_admin/admin/images_/$id')({
    component: ImageEditRoute,
    head: ({ params }) =>
        adminHead(
            params.id === 'new' ? 'תמונה חדשה' : 'עריכת תמונה',
            `/admin/images/${encodeURIComponent(params.id)}`,
        ),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: async ({ params }) => {
        if (params.id === 'new') return null;
        return adminGetImageFn({ data: { id: params.id } });
    },
});

function ImageEditRoute() {
    const image = Route.useLoaderData();
    const formKey = useAdminEditPageKey(
        image ? `${image.id}:${String(image.updatedAt)}` : undefined,
    );
    return <ImageEditPage key={formKey} image={image} />;
}
